/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import SwitcherItemWithDropdown from '../../primitives/item-with-dropdown';
import messages from '../../../common/utils/messages';
import { FormattedMessage } from 'react-intl-next';

const styles = cssMap({
	iconWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '32px',
		width: '32px',
	},
});

interface OverflowButtonProps {
	isExpanded: boolean;
	onClickOverflow: () => void;
}

const OverflowButton = ({ isExpanded, onClickOverflow }: OverflowButtonProps) => {
	const buttonText = !isExpanded ? messages.expandProductList : messages.collapseProductList;
	const icon = (
		<div css={styles.iconWrapper}>
			<ShowMoreHorizontalIcon label={`${buttonText} icon`} />
		</div>
	);
	return (
		<SwitcherItemWithDropdown
			icon={icon}
			children={<FormattedMessage {...buttonText} />}
			productName={undefined}
			onItemClick={onClickOverflow}
			testId="switcher-item__overflow-button"
		/>
	);
};

export default OverflowButton;
